export default __webpack_public_path__ + "static/media/icon_paquetes_selectos_off.fe58ebae.svg";